<tittel-verdi [tittel]="'Følgende medlemmer har ikke tilgang'|translate" class="skjermede">
  <verdi>
    @for (info of skjermedeMedlemmer(); track info.medlem.id) {
      <medlem-listevisning-kompakt [medlem]="info.medlem">
        @if (info.arvet) {
          <span class="arvet">{{ 'Arvet fra {forelder}'|translate: {forelder: typenavn().forelder} }}</span>
        }
      </medlem-listevisning-kompakt>
    }
  </verdi>
</tittel-verdi>
@if (visAarsak()) {
  <tittel-verdi [tittel]="'Angitt kommentar'|translate" [verdi]="skjerming().aarsak" class="årsak">
    <verdi><html-formatert [innhold]="skjerming().aarsak"/></verdi>
  </tittel-verdi>
}
<skjerming-beskrivelse [type]="type()"/>

